import React, { useState, useContext, useEffect } from 'react';
import {
  Modal,
  Card,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
  Table
} from 'react-bootstrap';
import AppContext from 'context/Context';

const ProductHelpModal = props => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const { modalShow, setModalShow } = props || {};

  const handleClose = () => {
    setModalShow(!modalShow);
  };

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="px-card border-bottom-0"
      >
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-vh-75 scrollbar">
        <Card className="mb-3">
          <Card.Header className="bg-200">
            <h5 className="mb-0">소</h5>
          </Card.Header>
          <Card.Body className="bg-light">
            <p className="mb-0">
              등록성분 (3개월) : 조단백질, 조지방, 조섬유, 회분, 수분, 칼슘, 인
            </p>
            <p className="mb-0">BSE (3개월) : -</p>
            <p className="mb-0">
              안전성 (6개월) : Aflatoxin, Ochratoxin, 납, 카드뮴, 비소, 수은,
              불소, 살모넬라
            </p>
            <p className="mb-0">아미노산 (6개월) : -</p>
            <p className="mb-0">동물용의약품 (1년) : 모낸신</p>
            <p className="mb-0">잔류농약 (1년) :</p>
            <p className="ps-4 mb-0">
              유기인계 : 다이아지논, 디클로르보스, 말라치온, 에디펜포스, 에치온,
              이피엔, 이소펜포스, 클로르피리포스, 클로르피리포스메칠, 파라치온,
              페니트로치온, 펜토에이트, 펜치온, 피리미포스메칠
            </p>
            <p className="ps-4 mb-0">
              유기염소계 : 비에치시, 디디티, 디엘드린(알드린포함), 엔드린,
              헵타크롤(헵타크롤에폭사이드 포함)
            </p>
            <p className="ps-4 mb-0">피레스로이드계 : 퍼메쓰린, 펜발러레이트</p>
            <p className="ps-4 mb-0">
              카바메이트계 : 카바릴, 페노브카브, 이소프로카브
            </p>
            <p className="ps-4 mb-0">벤지미다졸계 : 베노밀, 치아벤다졸</p>
            <p className="ps-4 mb-0">단성분 : 에칠렌디브로마이드</p>
          </Card.Body>
        </Card>
        <Card className="mb-3">
          <Card.Header className="bg-200">
            <h5 className="mb-0">닭</h5>
          </Card.Header>
          <Card.Body className="bg-light">
            <p className="mb-0">
              등록성분 (3개월) : 조단백질, 조지방, 조섬유, 회분, 수분, 칼슘, 인
            </p>
            <p className="mb-0">BSE (3개월) : -</p>
            <p className="mb-0">
              안전성 (6개월) : Aflatoxin, Ochratoxin, 납, 카드뮴, 비소, 수은,
              불소, 셀레늄, 살모넬라
            </p>
            <p className="mb-0">아미노산 (6개월) : Cystine, Methionine</p>
            <p className="mb-0">동물용의약품 (1년) : 모낸신</p>
            <p className="mb-0">잔류농약 (1년) :</p>
            <p className="ps-4 mb-0">
              유기인계 : 다이아지논, 디클로르보스, 말라치온, 에디펜포스, 에치온,
              이피엔, 이소펜포스, 클로르피리포스, 클로르피리포스메칠, 파라치온,
              페니트로치온, 펜토에이트, 펜치온, 피리미포스메칠
            </p>
            <p className="ps-4 mb-0">
              유기염소계 : 비에치시, 디디티, 디엘드린(알드린포함), 엔드린,
              헵타크롤(헵타크롤에폭사이드 포함)
            </p>
            <p className="ps-4 mb-0">피레스로이드계 : 퍼메쓰린, 펜발러레이트</p>
            <p className="ps-4 mb-0">
              카바메이트계 : 카바릴, 페노브카브, 이소프로카브
            </p>
            <p className="ps-4 mb-0">벤지미다졸계 : 베노밀, 치아벤다졸</p>
            <p className="ps-4 mb-0">단성분 : 에칠렌디브로마이드</p>
          </Card.Body>
        </Card>
        <Card className="mb-3">
          <Card.Header className="bg-200">
            <h5 className="mb-0">돼지</h5>
          </Card.Header>
          <Card.Body className="bg-light">
            <p className="mb-0">
              등록성분 (3개월) : 조단백질, 조지방, 조섬유, 회분, 수분, 칼슘, 인
            </p>
            <p className="mb-0">BSE (3개월) : -</p>
            <p className="mb-0">
              안전성 (6개월) : Aflatoxin, Ochratoxin, 납, 카드뮴, 비소, 수은,
              불소, 셀레늄, 살모넬라
            </p>
            <p className="mb-0">아미노산 (6개월) : Lysine</p>
            <p className="mb-0">동물용의약품 (1년) : 모낸신</p>
            <p className="mb-0">잔류농약 (1년) :</p>
            <p className="ps-4 mb-0">
              유기인계 : 다이아지논, 디클로르보스, 말라치온, 에디펜포스, 에치온,
              이피엔, 이소펜포스, 클로르피리포스, 클로르피리포스메칠, 파라치온,
              페니트로치온, 펜토에이트, 펜치온, 피리미포스메칠
            </p>
            <p className="ps-4 mb-0">
              유기염소계 : 비에치시, 디디티, 디엘드린(알드린포함), 엔드린,
              헵타크롤(헵타크롤에폭사이드 포함)
            </p>
            <p className="ps-4 mb-0">피레스로이드계 : 퍼메쓰린, 펜발러레이트</p>
            <p className="ps-4 mb-0">
              카바메이트계 : 카바릴, 페노브카브, 이소프로카브
            </p>
            <p className="ps-4 mb-0">벤지미다졸계 : 베노밀, 치아벤다졸</p>
            <p className="ps-4 mb-0">단성분 : 에칠렌디브로마이드</p>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header className="bg-200">
            <h5 className="mb-0">공정</h5>
          </Card.Header>
          <Card.Body className="bg-light">
            <p className="mb-0">플러싱 (3개월) : 펜벤다졸</p>
            <p className="mb-0">승강기 (3개월) : 아플라톡신</p>
            <p className="mb-0">B투입구 공정물 플러싱 (6개월) : 펜벤다졸</p>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer className="px-card border-top-0 align-items-center justify-content-center">
        <Button variant="secondary" onClick={handleClose}>
          닫기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductHelpModal;
